import './NoRecordFound.css';
import React from 'react';

function NoRecordFound() {
    return (
        <div className="no-record-found">
            <h5><i className="fa fa-meh-o"></i> Oops! No record found.</h5>
            <p>Try browsing different categories.</p>
        </div>
    )
}

export default NoRecordFound
